import { gql } from '@apollo/client';

export const CUSTOMER_ACCOUNT_FIELDS = gql`
    fragment CustomerAccountFields on CustomerAccountType {
        accountId
        accountNumber
        status
        channelId
        createdAt
        plainPassword
        roleCode
        roleName
    }
`;

export const CUSTOMER_OPERATION_LOG_FIELDS = gql`
    fragment CustomerOperationLogFields on CustomerOperationLogType {
        id
        operationType
        operatorName
        detailJson
        createdAt
    }
`;

export interface CustomerAccountType {
    accountId: number;
    accountNumber: string;
    status: string;
    channelId: number;
    createdAt?: string;
    plainPassword?: string;
    /** CUSTOMER_ADMIN / CUSTOMER_VIEWER */
    roleCode?: string;
    roleName?: string;
}

export const CUSTOMER_ROLE_ADMIN = 'CUSTOMER_ADMIN';
export const CUSTOMER_ROLE_OPERATOR = 'CUSTOMER_VIEWER';
export type CustomerRoleCode = typeof CUSTOMER_ROLE_ADMIN | typeof CUSTOMER_ROLE_OPERATOR;

export interface CustomerOperationLogType {
    id: number;
    operationType: string;
    operatorName: string;
    detailJson?: string;
    createdAt?: string;
}

export interface CustomerOperationLogPage {
    content: CustomerOperationLogType[];
    totalElements: number;
    page: number;
    size: number;
}
